import Text from "components/common/Text";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";

const AMENITIES = ({ props }) => {
  const classes = useStyles();
  const arr = props?.map((props, i) => (
    <Box
      className={classes.amenities}
      key={i}
      sx={{
        width: "213px",
        border: "1px solid #EBEBEB",
        borderRadius: "4px",
        display: "flex",
        flexDirection: "row",
        marginRight: "10px",
        padding: "20px 15px 15px 15px",
      }}
    >
      <Box
        sx={{
          objectFit: "contain",
          width: "25px",
          height: "25px",
          position: "relative",
          top: "5px",
        }}
      >
        <img
          src={props.Image ? props.Image : ""}
          width="100%"
          height="100%"
          alt=""
        />
      </Box>
      <Box sx={{ padding: "10px" }}>
        <Text
          variant="h"
          component="div"
          className={classes.station_amenities}
          gutterBottom
          sx={{
            font: "normal normal normal 16px/24px Nunito Sans",
            color: "#707070",
          }}
        >
          {props.name}
        </Text>
      </Box>
    </Box>
  ));

  return <>{arr}</>;
};

const useStyles = makeStyles((theme) => ({
  amenities: {
    marginBottom: "10px",

    ["@media (max-width:768px)"]: {
      marginTop: "15px",
      padding: "20px 35px 15px 29px",
      justifyContent: "space-around",
    },
  },
}));

export default AMENITIES;
